import script from "./AuditLog.vue?vue&type=script&setup=true&lang=js"
export * from "./AuditLog.vue?vue&type=script&setup=true&lang=js"

import "./AuditLog.vue?vue&type=style&index=0&id=2cd69199&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2cd69199"]])

export default __exports__